import { useState, useEffect } from 'react';
import config from '../config';

const defaultOperationalStates = {};
const defaultCogTileServCollections = [];

async function requestOperationalStates() {
  let response = await fetch(config.usaStatesURL);
  if (!response.ok) {
    throw new Error(
      `status=${response.status}, headers=${JSON.stringify(response.headers)}`
    );
  }
  let data = await response.json();
  // await new Promise(r => setTimeout(r, 2000)); // DEBUG simulate slow response
  return data;
}

async function requestCogTileServCollections() {
  let response = await fetch(
    config.cogTileServURL + '/collections?include_crs=false'
  );
  if (!response.ok) {
    throw new Error(
      `status=${response.status}, headers=${JSON.stringify(response.headers)}`
    );
  }
  let data = await response.json();
  // await new Promise(r => setTimeout(r, 2000)); // DEBUG simulate slow response
  return data;
}

export default function useOperationalStates() {
  const [operationalStates, setOperationalStates] = useState(
    defaultOperationalStates
  );
  const [cogTileServCollections, setCogTileServCollections] = useState(
    defaultCogTileServCollections
  );
  const [stateData, setStateData] = useState(defaultOperationalStates);

  useEffect(() => {
    requestOperationalStates()
      .then((data) => {
        setOperationalStates(data);
      })
      .catch((error) => {
        console.error(`Failed to fetch operational states: ${error}`);
        setOperationalStates(defaultOperationalStates);
      });

    requestCogTileServCollections()
      .then((data) => {
        setCogTileServCollections(data);
      })
      .catch((error) => {
        console.error(`Failed to fetch operational states: ${error}`);
        setCogTileServCollections(defaultCogTileServCollections);
      });
  }, []);

  // add the cog_tileserv info to the operational states data
  useEffect(() => {
    if (
      cogTileServCollections.length > 0 &&
      Object.keys(operationalStates).length > 0
    ) {
      let stData = {};
      Object.keys(operationalStates).forEach((element) => {
        const obj = operationalStates[element];
        const vrtInfo = cogTileServCollections.filter((elem) => {
          return elem.gdal_path.includes(`fcast-${obj.abbreviation}.vrt`);
        })[0];
        // in case we dont have tiles created yet
        if (vrtInfo) {
          stData[element] = {
            ...obj,
            cogTileServ: {
              URL:
                config.cogTileServURL +
                `/fcast-${obj.abbreviation}.vrt/tile/{z}/{x}/{y}.png`,
              bounds: [
                vrtInfo.min_x,
                vrtInfo.min_y,
                vrtInfo.max_x,
                vrtInfo.max_y
              ]
            }
          };
        } else {
          stData[element] = {
            ...obj
          };
        }
      });
      setStateData(stData);
    }
  }, [cogTileServCollections, operationalStates]);

  return stateData;
}
